module.exports = __webpack_public_path__ + "static/media/dun_dun_dun.92c3bace.wav";